import axios from 'axios'
const API_URL = process.env.REACT_APP_BACKEND_API

export const createAPIClient = function createAPIClient () {
  return axios.create({
    baseURL: API_URL,
    timeout: 9000,
    headers: {'Authorization': `Bearer ${window.localStorage.getItem('token')}`}
  })
}

export const API = createAPIClient()

export const anonAPI = axios.create({
  baseURL: API_URL,
  timeout: 6000
})

export const createAWSClient = function createAWSClient () {
  return axios.create()
}



// WEBPACK FOOTER //
// ./src/services/api.js